import axios from '../axios/axios-auth'

export default class AnomaliasOrderService {

    createOrder(orgId, order) {
        return axios.post(`/anomalies-service/v1/organizations/${orgId}/anomalies/orders`, order).then(response => response.data)
    }

    getOrdersByOrganization(orgId, start, end) {
        return axios.get(`/anomalies-service/v1/organizations/${orgId}/anomalies/orders/date/${start}/${end}`).then(response => response.data)
    }

    deleteOrder(orderId) {
        return axios.delete(`/anomalies-service/v1/anomalies/orders/${orderId}`).then(response => response.data)
    }

    updateOrder(orderId, order) {
        return axios.patch(`/anomalies-service/v1/anomalies/orders/${orderId}`, order).then(response => response.data)
    }

    closeOrder(orderId, data) {
        return axios.patch(`/anomalies-service/v1/anomalies/orders/${orderId}/close`, data).then(response => response.data)
    }

    getFieldOrders(fieldId) {
        return axios.get(`/anomalies-service/v1/fields/${fieldId}/anomalies/orders`).then(response => response.data)
    }
}
